import React from 'react';
import { AgeVerification as InnerField } from '@common/components/Account/components/AgeVerification';
import { useAccountRules } from '@common/components/AccountMultiStep/rules/useAccountRules';
import { FieldWrapper } from '../FieldWrapper';

export function AgeVerification() {
  const { ageVerificationConsentRules } = useAccountRules();
  return (
    <FieldWrapper<boolean>
      name="ageVerification"
      rules={ageVerificationConsentRules}
      render={(props) => <InnerField {...props} />}
    />
  );
}
